import api from '@/services/Http'

export const putAccountMe = async data =>
  (await api()).put('/sync/account/me', data)
